/* PSM homepage v2: drop calendar, header, mobile menu, reveal, armor explorer, signup validation. */
(function () {
  const doc = document.documentElement;
  const cs = (doc.lang || 'en').toLowerCase().startsWith('cs');
  const de = (doc.lang || 'en').toLowerCase().startsWith('de');
  const locale = cs ? 'cs-CZ' : de ? 'de-DE' : 'en-GB';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ================= drop calendar =================
     Rule: the drop opens on the 1st, every order ships together on the ship day
     (section setting, default 28). Computed in the visitor's browser in Prague time
     on each page load, because Shopify caches page HTML. Rolls over by itself. */
  const shipEl = $('[data-ship-day]');
  const SHIP = shipEl ? parseInt(shipEl.dataset.shipDay, 10) || 28 : 28;
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Prague', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
  const get = (t) => +parts.find((x) => x.type === t).value;
  const Y = get('year'), M = get('month'), D = get('day');
  const utc = (y, m, d) => new Date(Date.UTC(y, m - 1, d));
  const dayMonth = (y, m, d) => new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(utc(y, m, d));
  const monthYear = (y, m) => new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(utc(y, m, 1));
  const ny = M === 12 ? Y + 1 : Y, nm = M === 12 ? 1 : M + 1;
  const afterShip = D > SHIP;
  const cy = afterShip ? ny : Y, cm = afterShip ? nm : M;
  const shipDate = dayMonth(Y, M, SHIP), nextDrop = dayMonth(ny, nm, 1), nextShip = dayMonth(ny, nm, SHIP);
  const daysInMonth = new Date(Date.UTC(Y, M, 0)).getUTCDate();
  const plural = (n, one, few, many) => (n === 1 ? one : (cs && n < 5 ? few : many));

  const T = cs ? {
    wd: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
    toShip: (n) => `${n} ${plural(n, 'den', 'dny', 'dní')} do expedice`,
    opens: (n) => `Nový drop za ${n} ${plural(n, 'den', 'dny', 'dní')}`,
    shipDay: 'Den expedice',
    live: [`<strong>Drop je v prodeji.</strong> Objednávky odešleme společně ${shipDate}.`, `Objednejte do ${shipDate} a zbroj odejde s touto várkou.`],
    last: ['<strong>Dnes expedujeme.</strong> Dnešní objednávky odejdou ještě dnes.', 'Dnes je den expedice. Dnešní objednávky odejdou ještě dnes.'],
    after: [`<strong>Várka tohoto měsíce je odeslaná.</strong> Nové objednávky odejdou ${nextShip}.`, `Várka tohoto měsíce je odeslaná. Objednejte teď a zbroj odejde ${nextShip}. Nové kusy přidáme ${nextDrop}.`],
    hint: 'Ťukněte na + a uvidíte díl',
    emailEmpty: 'Zadejte e-mailovou adresu.',
    emailBad: 'Tahle adresa vypadá neúplně.'
  } : de ? {
    wd: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
    toShip: (n) => `${n} ${n === 1 ? 'Tag' : 'Tage'} bis zum Versand`,
    opens: (n) => `Neuer Drop in ${n} ${n === 1 ? 'Tag' : 'Tagen'}`,
    shipDay: 'Versandtag',
    live: [`<strong>Der Drop läuft.</strong> Alle Bestellungen gehen gemeinsam am ${shipDate} raus.`, `Bestellen Sie bis zum ${shipDate}, dann geht Ihre Rüstung mit dieser Charge raus.`],
    last: ['<strong>Heute ist Versandtag.</strong> Heutige Bestellungen gehen noch heute raus.', 'Heute ist Versandtag. Heutige Bestellungen gehen noch heute raus.'],
    after: [`<strong>Die Charge dieses Monats ist verschickt.</strong> Neue Bestellungen gehen am ${nextShip} raus.`, `Die Charge dieses Monats ist raus. Bestellen Sie jetzt, Versand am ${nextShip}. Neue Teile kommen am ${nextDrop}.`],
    hint: 'Tippen Sie auf +, um das Teil zu sehen',
    emailEmpty: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
    emailBad: 'Diese Adresse sieht unvollständig aus.'
  } : {
    wd: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    toShip: (n) => `${n} ${plural(n, 'day', 'days', 'days')} to dispatch`,
    opens: (n) => `New drop in ${n} ${plural(n, 'day', 'days', 'days')}`,
    shipDay: 'Dispatch day',
    live: [`<strong>The drop is live.</strong> Orders ship together on ${shipDate}.`, `Order by ${shipDate} and it ships with this month's batch.`],
    last: ['<strong>Dispatch day.</strong> Orders placed today ship today.', 'Today is dispatch day. Orders placed today still ship today.'],
    after: [`<strong>This month's batch has shipped.</strong> New orders ship on ${nextShip}.`, `This month's batch is out. Order now and it ships on ${nextShip}. New pieces drop on ${nextDrop}.`],
    hint: 'Tap + to see the piece',
    emailEmpty: 'Enter your email address.',
    emailBad: 'That email address looks incomplete.'
  };

  const cal = $('#cal');
  let state = afterShip ? T.after : (D === SHIP ? T.last : T.live);
  let count = afterShip ? T.opens(daysInMonth - D + 1) : (D === SHIP ? T.shipDay : T.toShip(SHIP - D));
  if (cal) {
    const days = new Date(Date.UTC(cy, cm, 0)).getUTCDate();
    const offset = (utc(cy, cm, 1).getUTCDay() + 6) % 7;
    let html = `<div class="cal-head"><span class="cal-month">${monthYear(cy, cm)}</span><span class="cal-count">${count}</span></div><div class="cal-grid">`;
    html += T.wd.map((w) => `<span class="wd">${w}</span>`).join('') + '<span></span>'.repeat(offset);
    for (let d = 1; d <= days; d++) {
      const c = ['day'];
      if (d === 1) c.push('drop'); else if (d === SHIP) c.push('ship'); else if (d < SHIP) c.push('open'); else c.push('out');
      const today = !afterShip && d === D;
      if (today) c.push('today');
      if (!afterShip && d < D && d !== 1) c.push('past');
      html += `<span class="${c.join(' ')}"${today ? ' aria-current="date"' : ''}>${d}</span>`;
    }
    cal.innerHTML = html + '</div>';
    const st = $('#drop-status'); if (st) st.textContent = state[1];
  }
  // the sentence after the bold status is dropped on phones (.db-more), so the stock count fits on one line
  const bar = $('#dropbar-text'); if (bar) bar.innerHTML = state[0].replace('</strong> ', '</strong><span class="db-more"> ') + '</span>';
  const nd = $('#next-drop'); if (nd) nd.textContent = nextDrop;

  /* ================= how-drops-work page: live line + ship-date calculator =================
     The slider picks a day of the current month (default today). Orders up to the ship day
     leave on this month's ship day; later orders leave on next month's. */
  const dwMonth = $('#dw-month');
  if (dwMonth) { const m = monthYear(Y, M); dwMonth.textContent = (cs || de) ? `Drop · ${m}` : `${m} drop`; }
  const dwDays = $('#dw-days'); if (dwDays) dwDays.textContent = count;
  const dwc = $('#dwc');
  if (dwc) {
    const slider = $('#dwc-slider'), reset = $('#dwc-reset');
    const elDate = $('#dwc-date'), elOrder = $('#dwc-order'), elShip = $('#dwc-ship'), elWait = $('#dwc-wait');
    const W = cs
      ? { today: (d) => `dnes, ${d}`, wait: (n) => (n === 0 ? 'odchází ještě týž den' : `${n} ${plural(n, 'den', 'dny', 'dní')} čeká v kovárně`) }
      : de ? { today: (d) => `heute, ${d}`, wait: (n) => (n === 0 ? 'geht noch am selben Tag raus' : `${n} ${n === 1 ? 'Tag' : 'Tage'} Wartezeit in der Schmiede`) }
      : { today: (d) => `today, ${d}`, wait: (n) => (n === 0 ? 'ships the same day' : `${n} ${n === 1 ? 'day' : 'days'} waiting at the forge`) };
    const hourglass = '<i class="ph ph-hourglass-medium" aria-hidden="true"></i>';
    dwc.style.setProperty('--days', daysInMonth);
    slider.max = daysInMonth;
    const draw = (pick) => {
      const order = dayMonth(Y, M, pick);
      const ship = pick <= SHIP ? dayMonth(Y, M, SHIP) : nextShip;
      const wait = Math.round(((pick <= SHIP ? Date.UTC(Y, M - 1, SHIP) : Date.UTC(ny, nm - 1, SHIP)) - Date.UTC(Y, M - 1, pick)) / 864e5);
      elDate.textContent = pick === D ? W.today(order) : order;
      elOrder.textContent = order;
      elShip.textContent = ship;
      elWait.innerHTML = hourglass + W.wait(wait); elWait.hidden = false;
      reset.hidden = pick === D;
      slider.setAttribute('aria-valuetext', `${order} → ${ship}`);
    };
    slider.value = D; draw(D);
    slider.addEventListener('input', () => draw(+slider.value));
    reset.addEventListener('click', () => { slider.value = D; draw(D); slider.focus(); });
  }

  /* ================= header ================= */
  const header = $('#header');
  const dropbar = $('.dropbar');
  if (header && dropbar && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      header.classList.toggle('solid', !e.isIntersecting);
      header.classList.toggle('on-hero', e.isIntersecting);
    }).observe(dropbar);
  }

  /* ================= mobile menu ================= */
  const mb = $('#menu-btn'), mm = $('#mobile-menu');
  if (mb && mm) {
    mb.addEventListener('click', () => {
      const open = mm.classList.toggle('open');
      mm.style.setProperty('--menu-top', header.getBoundingClientRect().bottom + 'px');
      mb.setAttribute('aria-expanded', open);
      mb.querySelector('i').className = open ? 'ph ph-x' : 'ph ph-list';
      header.classList.toggle('solid', open || !header.classList.contains('on-hero'));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    $$('a', mm).forEach((a) => a.addEventListener('click', () => { if (mm.classList.contains('open')) mb.click(); }));
  }

  /* ================= reveal ================= */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('in'));
  }

  /* ================= armor explorer =================
     Touch first: tabs pick the body part, the figure zooms to it and only its points
     are live (44px targets). Tapping a point opens a label, and the label links to the
     product. Zoom values are tuned to the full-harness cutout photo. */
  const stage = $('#stage'), zoom = $('#zoom');
  if (stage && zoom) {
    const ZOOM = { head: { s: 1.9, x: 51, y: 16 }, torso: { s: 1.55, x: 47, y: 48 }, arms: { s: 1.6, x: 36, y: 29 }, legs: { s: 1.45, x: 45, y: 74 } };
    const tip = $('#tip'), hint = $('#stage-hint');
    const tabs = $$('.cat'), spots = $$('.spot'), rows = $$('.row');
    let picked = null;
    const spotFor = (k) => spots.find((s) => s.dataset.key === k);
    function placeTip(spot) {
      const sr = stage.getBoundingClientRect(), r = spot.getBoundingClientRect();
      const cx = r.left + r.width / 2 - sr.left, cy = r.top + r.height / 2 - sr.top;
      const w = tip.offsetWidth, h = tip.offsetHeight;
      const x = Math.min(Math.max(cx - w / 2, 8), sr.width - w - 8);
      let y = cy - h - 18; if (y < 8) y = cy + 22;
      tip.style.transform = `translate(${x}px,${y}px)`;
    }
    function pick(key) {
      picked = key;
      if (key) stage.classList.add('touched'); // stop the attention pulse after the first tap
      spots.forEach((s) => s.classList.toggle('on', s.dataset.key === key));
      rows.forEach((r) => r.classList.toggle('on', r.dataset.key === key));
      const s = spotFor(key);
      if (!s) { tip.classList.remove('show'); tip.tabIndex = -1; return; }
      tip.href = s.dataset.href;
      tip.innerHTML = `${s.dataset.name}<span>${s.dataset.price}</span><i class="ph ph-arrow-right" aria-hidden="true"></i>`;
      tip.tabIndex = 0; tip.classList.add('show');
      if (hint) hint.style.opacity = 0;
      placeTip(s);
    }
    function setCat(c) {
      tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.cat === c));
      $$('.panel').forEach((p) => { p.hidden = p.dataset.cat !== c; });
      spots.forEach((s) => { const live = s.dataset.cat === c; s.classList.toggle('live', live); s.tabIndex = live ? 0 : -1; });
      const z = ZOOM[c] || { s: 1, x: 50, y: 50 };
      zoom.style.setProperty('--s', z.s); zoom.style.setProperty('--x', z.x + '%'); zoom.style.setProperty('--y', z.y + '%');
      pick(null); if (hint) hint.style.opacity = '';
    }
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => setCat(t.dataset.cat));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; n.focus(); n.click();
      });
    });
    spots.forEach((s) => {
      s.addEventListener('click', () => (picked === s.dataset.key ? pick(null) : pick(s.dataset.key)));
      s.addEventListener('focus', () => { if (s.matches(':focus-visible')) pick(s.dataset.key); }); // keyboard only
    });
    const fine = window.matchMedia('(hover:hover) and (pointer:fine)');
    rows.forEach((r) => {
      r.addEventListener('mouseenter', () => { if (fine.matches) pick(r.dataset.key); });
      r.addEventListener('focus', () => pick(r.dataset.key));
    });
    stage.addEventListener('click', (e) => { if (e.target === stage || e.target.tagName === 'IMG') pick(null); });
    const replace = () => { if (picked) { const s = spotFor(picked); if (s) placeTip(s); } };
    zoom.addEventListener('transitionend', replace);
    window.addEventListener('resize', replace);
    const first = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0];
    if (first) setCat(first.dataset.cat);
    if (hint) hint.textContent = T.hint;
  }

  /* ================= newsletter: block empty/invalid, otherwise real submit ================= */
  const form = $('#psm2-signup');
  if (form) {
    const em = $('#psm2-email'), msg = $('#psm2-signup-msg');
    form.addEventListener('submit', (e) => {
      if (em.value.trim() && em.checkValidity()) return;
      e.preventDefault();
      em.setAttribute('aria-invalid', 'true'); msg.className = 'msg err';
      msg.textContent = em.value.trim() ? T.emailBad : T.emailEmpty;
      em.focus();
    });
    em.addEventListener('input', () => { if (em.getAttribute('aria-invalid')) { em.removeAttribute('aria-invalid'); msg.textContent = ''; msg.className = 'msg'; } });
  }
})();
